import React, { useState, useEffect } from "react";
import { Table, Button } from "antd";
import axios from "axios";
import Swal from "sweetalert2";
import { Spinner } from "react-bootstrap";
import whatsapp from "../../../src/assets/img/WhatsApp_icon.png";
import { Link, useNavigate, useParams } from "react-router-dom";

export default function Resulthistory() {
  const user_id = localStorage.getItem("userid");
  const [isLoading, setIsLoading] = useState(true);
  const devid = localStorage.getItem("dev_id");

  const [data, setData] = useState([]);
  const [totalComm, settotalComm] = useState([]);
  const [totalPlayed, settotalPlayed] = useState([]);
  const [Refcomm, setRefcomm] = useState([]);
  const [RefBonus, setRefBonus] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [showButton, setShowButton] = useState(false);
  const [ref_message, setref_message] = useState(null);
  const [apiResponse, setApiResponse] = useState(null);

  const [redeemAmount, setRedeemAmount] = useState("");
  const [TotalBonus, setTotalBonus] = useState("");
  const [BonusMin, setBonusMin] = useState("");
  const [BonusMax, setBonusMax] = useState("");
  const [error, setError] = useState("");
  const [loadingbutton, setLoadingbutton] = useState(false);
  const [refData, setRefData] = useState({ ref_code: "", ref_by: "" });
  const [loadingButton, setLoadingButton] = useState(false);
  const [loadButton, setLoadButton] = useState(false);
  const [itemsToShow, setItemsToShow] = useState(20);

  const getProfile = async () => {
    setLoadButton(false);
    const apiUrl = `${process.env.REACT_APP_API_URL_NODE}user-profile`;
    const requestData = {
      app_id: process.env.REACT_APP_API_ID,
      user_id,
      device_id: devid,
    };
    const datasend = { data: requestData };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(datasend),
      });

      const response1 = await response.json();
      const data = response1;
      setLoadButton(true);

      if (data.is_login === "0") window.location.href = "/";
      if (data.success === "1") {
        setApiResponse(data.data.is_bonus);
        setref_message(data.data.ref_message);
        setRefData({ ref_code: data.data.ref_code, ref_by: data.data.ref_by });
        setShowButton(!data.data.ref_by);
      } else {
        console.error("API Error:", data.message);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearch = (value) => {
    const filtered = data.filter((item) =>
      Object.values(item).some(
        (field) =>
          typeof field === "string" &&
          field.toLowerCase().includes(value.toLowerCase()),
      ),
    );
    setSearchText(value);
    setFilteredData(filtered);
    setCurrentPage(1);
  };

  const bonuslist = async (date) => {
    const user_id = localStorage.getItem("userid");
    const requestData = {
      user_id: user_id,
      date: date,
    };
    const datasend = { data: requestData };
    const config = {
      method: "POST",
      url: `${process.env.REACT_APP_API_URL_NODE}bonus-report-list-details-first`,
      headers: {
        "Content-Type": "application/json",
      },
      data: datasend,
    };
    try {
      const response1 = await axios(config);
      const response = response1.data;
      console.warn("response1 rammm", response);

      if (response.success == "1") {
        setData(response.data);
        settotalComm(response.total_comm);
        settotalPlayed(response.total_played);
        setRefcomm(response.commissionRate);
        setRefBonus(response.total_comm);
        setTotalBonus(response.total_bonus);
        setBonusMin(response.bounsmin);
        setBonusMax(response.bounsmax);
      } else {
        console.log("no record found");
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  const { date } = useParams();
  useEffect(() => {
    bonuslist(date);
    getProfile();
  }, [date]);

  const navigate = useNavigate();

  const columns = [
    {
      title: "Child Mobile",
      dataIndex: "child_mob",
      key: "child_mob",
    },
    {
      title: "Total Played",
      dataIndex: "total_bet_value",
      key: "total_bet_value",
      render: (value) => value ?? "0",
    },
    {
      title: "Bonus ",
      dataIndex: "total_win_value",
      key: "total_win_value",
      render: (value) => value ?? "0",
    },
    {
      title: "View",
      key: "view",
      render: (_, record) => (
        <Button
          type="primary"
          onClick={() =>
            navigate(`/bonus-report-details-views/${date}/${record.child_mob}`)
          }
        >
          View
        </Button>
      ),
    },
  ];

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    });
    return () => clearTimeout(timer);
  }, []);

  const redeemBonus = async (event) => {
    event.preventDefault();
    if (!redeemAmount || redeemAmount < BonusMin || redeemAmount > BonusMax) {
      setError(
        "Please enter a valid amount between " + BonusMin + " and " + BonusMax,
      );
      return;
    }
    setError("");
    setLoadingbutton(true);
    const requestData = {
      user_id: user_id,
      amount: redeemAmount,
    };
    const datasend = { data: requestData };
    const config = {
      method: "POST",
      url: `${process.env.REACT_APP_API_URL_NODE}bonus-report-redem`,
      headers: {
        "Content-Type": "application/json",
      },
      data: datasend,
    };
    try {
      const response1 = await axios(config);
      const response = response1.data;
      console.warn("bonus-report-list-details-first FULL RESPONSE:", response);

      if (response.success == "1") {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Your bonus has been redeemed successfully!",
        });
        bonuslist();
        setLoadingbutton(false);
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response.message,
        });
      }
    } catch (error) {
      console.error("Error redeeming bonus:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred while redeeming your bonus. Please try again later.",
      });
    }
  };

  const loadMore = () => {
    setItemsToShow(itemsToShow + 20);
  };

  const copyToClipboard = () => {
    navigator.clipboard
      .writeText(
        "https://ranabhaimatka.com/create-account?reffercode=" +
          refData.ref_code,
      )
      .then(() => {
        Swal.fire(
          "Copied!",
          "Your refer Link has been copied to the clipboard.",
          "success",
        );
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
        Swal.fire("Error", "Failed to copy the refer code.", "error");
      });
  };

  const copyToClipboard1 = () => {
    navigator.clipboard
      .writeText(refData.ref_code)
      .then(() => {
        Swal.fire(
          "Copied!",
          "Your refer Code has been copied to the clipboard.",
          "success",
        );
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
        Swal.fire("Error", "Failed to copy the refer code.", "error");
      });
  };

  return (
    <div>
      {isLoading && (
        <div className="spinner-wrapper">
          <div className="loadernew2"></div>
        </div>
      )}
      {!isLoading && (
        <section id="Help" className="margin-bottom-88">
          <div className="margin-bottom-49 mb-0">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <p className="referalcode">
                    अगर आप अपने रेफरल कोड से किसी को जोड़ते हैं, तो आपको उसकी
                    खेली हुई गेम का 5% कमीशन तुरंत मिलेगा।{" "}
                  </p>
                </div>

                <div className="col-md-12 mt-3">
                  <Table
                    dataSource={
                      searchText
                        ? filteredData.slice(0, itemsToShow)
                        : data.slice(0, itemsToShow)
                    }
                    columns={columns}
                    pagination={false}
                  />
                  {data.length > itemsToShow && (
                    <div style={{ textAlign: "center", marginTop: "20px" }}>
                      <Button onClick={loadMore}>Load More</Button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </div>
  );
}